import { buildBrandPath } from "@/hooks/use-route-brand";

export type FocusedPostEditorOwner = {
  type: "campaign" | "standalone";
  id: string;
};

export type FocusedPostEditorState = {
  backgroundLocation?: unknown;
};

export const buildFocusedPostEditorPath = ({
  brandId,
  owner,
  postId,
}: {
  brandId: string;
  owner: FocusedPostEditorOwner;
  postId: string;
}): string =>
  owner.type === "campaign"
    ? buildBrandPath(brandId, `/editor/campaigns/${owner.id}/posts/${postId}`)
    : buildBrandPath(brandId, `/editor/posts/batches/${owner.id}/posts/${postId}`);
